import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fr } from '../locales/fr';
import { en } from '../locales/en';
import { us } from '../locales/us';
import appstore from '../appstore.png';
import googleplay from '../googleplay.png';

function CodeRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [storeUrls, setStoreUrls] = useState({ appStore: '', playStore: '', isApple: false });

  // Système de traduction comme dans App.js
  const translations = {
    '/fr': fr,
    '/en': en,
    '/us': us
  };
  const getTranslation = () => {
    if (location) {
        const userLang = navigator.language || navigator.userLanguage;
      if (userLang.startsWith('fr')) {
        return fr;
      } else if (userLang.startsWith('en')) {
        return en;
      } 
    }
      return translations[location.pathname] || us;
    }

  let t = getTranslation();

useEffect(() => {
    t = getTranslation()
}, [location.pathname])
  // Sélection de la langue basée sur l'URL ou la langue du navigateur

    


  const isValidCode = (c) => {
    if (!c) return false;
    const codePattern = /^[a-zA-Z0-9]{5,35}$/;
    return codePattern.test(c);
  };

  useEffect(() => {
    if (!isValidCode(code)) {
      navigate('/404');
      return;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    const isApple = /iphone|ipad|ipod|macintosh/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    const isMobile = isApple || isAndroid;

    const appStoreUrl = "https://apps.apple.com/fr/app/linkount/id6737286047";
    const playStoreUrl = "https://play.google.com/store/apps/details?id=linkount.com";
    const appScheme = `linkevenapp://join/${code}`;

    // Stocker les URLs pour le bouton
    setStoreUrls({
      appStore: appStoreUrl,
      playStore: playStoreUrl,
      isApple: isApple
    });

    if (isMobile) {
      // 1. On prépare le timer de redirection vers le store
      let timer = setTimeout(() => {
        // SI après 2.5s la page est toujours visible, c'est que l'app n'est pas installée
        if (!document.hidden) {
          window.location.href = isApple ? appStoreUrl : playStoreUrl;
        }
      }, 10000);

      // 2. FONCTION DE DÉTECTION : Si l'utilisateur quitte le navigateur, c'est que l'app s'est ouverte
      const cancelRedirect = () => {
        console.log("App détective : L'application est installée et s'est ouverte.");
        clearTimeout(timer); // ON ANNULE LA REDIRECTION VERS LE STORE
      };

      // 3. Écouteurs pour détecter le basculement vers l'application
      window.addEventListener('visibilitychange', () => {
        if (document.hidden) cancelRedirect();
      });
      window.addEventListener('blur', cancelRedirect); // Très utile sur iOS Safari

      // 4. Tentative d'ouverture de l'application
      window.location.href = appScheme;

      // Nettoyage au démontage du composant
      return () => {
        clearTimeout(timer);
        window.removeEventListener('visibilitychange', cancelRedirect);
        window.removeEventListener('blur', cancelRedirect);
      };
    } else {
      window.location.href = isApple ? appStoreUrl : playStoreUrl;
    }
  }, [code, navigate]);

  const handleDownloadClick = () => {
    const url = storeUrls.isApple ? storeUrls.appStore : storeUrls.playStore;
    window.open(url, '_blank');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(225deg, #7a6a9e 0%, #8e7d9b 25%, #b0a1b6 50%, #d1c6d1 100%)',
      color: '#ffffff',
      fontFamily: 'Poppins-Medium, sans-serif'
    }}>
      <div style={{ textAlign: 'center', padding: '20px', maxWidth: '400px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '1.8rem' }}>{t.codeRedirectTitle}</h2>
        <p style={{ opacity: 0.9, marginBottom: '15px', fontSize: '1rem', lineHeight: '1.6' }}>
          {t.codeRedirectInstalled}
        </p>
        <p style={{ opacity: 0.8, fontSize: '0.95em', marginBottom: '30px', lineHeight: '1.6' }}>
          {t.codeRedirectDownload}
        </p>
        
        {/* Bouton de téléchargement */}
        <button
          onClick={handleDownloadClick}
          style={{
            background: 'rgba(255, 255, 255, 0.15)',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '16px',
            padding: '14px 28px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
            color: '#ffffff',
            fontSize: '1.1rem',
            fontFamily: 'Poppins-Medium, sans-serif',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            margin: '0 auto',
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))',
            fontWeight: '500'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
            e.currentTarget.style.filter = 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.3))';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
            e.currentTarget.style.filter = 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))';
          }}
        >
          <img 
            src={storeUrls.isApple ? appstore : googleplay} 
            alt="Télécharger" 
            style={{
              width: 32,
              height: 'auto',
            }}
          />
          {t.codeRedirectButton}
        </button>
      </div>
    </div>
  );
}

export default CodeRedirect;